<template>
  <div class="card">
    <div class="card-body">
      <p class="card-text mb-3">
        Slug Generator
      </p>
      <form @submit.prevent="generate">
        <div class="input-group">
          <input
            class="form-control"
            type="text"
            placeholder="Your text here ..."
            :disabled="disabled"
            v-model="text"
          >
          <div class="input-group-append">
            <button
              class="btn btn-outline-primary"
              type="submit"
              :disabled="disabled"
            >
              Transform
            </button>
          </div>
        </div>
        <small class="text-muted">Enter the text you want to transform into a slug</small>
      </form>

      <template v-if="slug.length > 0">
        <div class="input-group mt-3">
          <input
            class="form-control"
            type="text"
            :value="slug"
            readonly
          >
          <div
            v-if="copyIsAvailable"
            class="input-group-append"
          >
            <button
              class="btn btn-success"
              type="button"
              @click="copyToClipboard"
            >
              Copy
            </button>
          </div>
        </div>
        <small
          v-if="showCopiedText"
          class="text-success font-weight-bold"
        >Copied!</small>
      </template>
    </div>
  </div>
</template>

<script>
import http from '../../../http';
import notify from '../../../notifications';

export default {
    data() {
        return {
            disabled: false,
            showCopiedText: false,
            text: '',
            slug: ''
        };
    },
    computed: {
        copyIsAvailable() {
            return window.navigator && window.navigator.clipboard;
        }
    },
    methods: {
        async generate() {
            this.disabled = true;

            this.slug = '';

            const response = await http.get( `/slug/generate?text=${this.text}` );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to generate slug'
                } );
                this.disabled = false;
                return;
            }

            const responseBody = await response.json();

            this.slug = responseBody.slug;

            this.disabled = false;
            this.showCopiedText = false;
        },
        async copyToClipboard() {
            this.disabled = true;

            await window.navigator.clipboard.writeText( this.slug );

            this.showCopiedText = true;

            setTimeout( () => {
                this.showCopiedText = false;
            }, 2000 );

            this.disabled = false;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/utilities/slug-generator.vue